export default "__VITE_ASSET__Qqe8MsDk__"